import { authHeader, isTokenExpired } from "../helpers";

export const statsService = {
  getGlobalStats,
};

function getGlobalStats(filters) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };

  if (filters) requestOptions.body = JSON.stringify(filters);

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/statistics/expariences/global`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
